const theme = {
  bg: "#0B0B12",
  sidebar: "#0F0F18",
  card: "#14141F",
  cardHover: "#1A1A28",
  border: "#1E1E2E",
  text: "#FFFFFF",
  textMuted: "#6B7280",
  textSoft: "#9CA3AF",
  red: "#E8201A",
  green: "#1B8C2D",
  greenLight: "#22C55E",
  yellow: "#FACC15",
  blue: "#3B82F6",
  purple: "#8B5CF6",
  orange: "#F97316",
};

export const STATUS = {
  // Lojista avança manualmente até "pronto"
  novo:        { label: "Novo",               color: theme.red,       bg: "#2D0A0A", next: "Aceitar",                ns: "aceito",      nc: theme.green  },
  aceito:      { label: "Aceito",             color: theme.orange,    bg: "#2D1A0A", next: "Preparando",             ns: "preparando",  nc: theme.orange },
  preparando:  { label: "Preparando",         color: theme.orange,    bg: "#2D1A0A", next: "Ficou Pronto",           ns: "pronto",      nc: theme.blue   },
  // A partir de "pronto", o entregador assume — lojista só acompanha
  pronto:              { label: "Pronto",              color: theme.blue,      bg: "#0A1A2D", next: null },
  buscando_entregador: { label: "Buscando Entregador", color: theme.purple,    bg: "#1A0A2D", next: null },
  em_entrega:          { label: "Em Entrega",          color: theme.purple,    bg: "#1A0A2D", next: null },
  entregue:            { label: "Entregue",            color: theme.greenLight,bg: "#0A2D1A", next: null },
  cancelado:           { label: "Cancelado",           color: theme.red,       bg: "#2D0A0A", next: null },
};

export const PAY_LABELS  = { pix: "PIX", credito: "Crédito", debito: "Débito", dinheiro: "Dinheiro", cashback: "Cashback" };
export const PAY_COLORS  = { pix: theme.green, credito: theme.red, debito: theme.blue, dinheiro: theme.yellow, cashback: theme.purple };

export const fmt = (v) => "R$ " + Number(v || 0).toFixed(2).replace(".", ",");

export const DONE_STATUS   = ["entregue", "em_entrega"];
export const ACTIVE_STATUS = ["novo", "aceito", "preparando", "pronto", "buscando_entregador", "em_entrega"];

export const calcKpis = (list) => {
  const d = list.filter(o => DONE_STATUS.includes(o.status));
  const r = d.reduce((s, o) => s + Number(o.total || 0), 0);
  return { total: list.length, fat: r, avg: d.length > 0 ? r / d.length : 0, canc: list.filter(o => o.status === "cancelado").length };
};

export default theme;